import { useEffect } from "react";
import { Container, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";

import {
  getApprovalDetails,
  resetApprovalDetails,
} from "../../../redux/actions";
import CeroInfoPair from "../../../components/CeroInfoPair";
import useStyles from "./styles";

const Status = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const approvalSummaryDetails = useSelector(
    (state) => state.approval.approvalDetails.data
  );

  useEffect(() => {
    if (props.year && props.facility && props.auditId)
      dispatch(getApprovalDetails(props.year, props.facility, props.auditId));
    else dispatch(resetApprovalDetails());
  }, [props.year, props.facility, props.auditId, dispatch]);

  return (
    <Container className={classes.container}>
      <Grid spacing={2} className={classes.statusContainer}>
        <Grid item xs={6}>
          <CeroInfoPair
            title="Status"
            value={props.status}
            classes={{
              container: classes.infoContainer,
              value:
                props.status === "In Progress"
                  ? classes.Inprogress
                  : classes[props.status],
              title: classes.title,
            }}
          />
          <CeroInfoPair
            title="Audited By"
            value={
              approvalSummaryDetails.audited_by_name
                ? approvalSummaryDetails.audited_by_name
                : "NA"
            }
            classes={{ container: classes.infoContainer, title: classes.title }}
          />
          <CeroInfoPair
            title="Audited on"
            value={
              approvalSummaryDetails.audited_on
                ? dayjs(approvalSummaryDetails.audited_on).format("DD/MM/YYYY")
                : "NA"
            }
            classes={{ container: classes.infoContainer, title: classes.title }}
          />
        </Grid>
        <Grid item xs={6}>
          <CeroInfoPair
            title="Approval Cycle"
            value={approvalSummaryDetails.approval_cycle_type
              ?.split("_")
              .join(" ")}
            classes={{ container: classes.infoContainer, title: classes.title }}
          />
          <CeroInfoPair
            title="Audit Cycle"
            value={approvalSummaryDetails.audit_cycle_type
              ?.split("_")
              .join(" ")}
            classes={{ container: classes.infoContainer, title: classes.title }}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Status;
